import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  Button,
} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink
            to="about"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            Why
          </SidebarLink>
          <SidebarLink
            to="discover"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            What
          </SidebarLink>
          <SidebarLink
            to="retreat"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            Retreats
          </SidebarLink>
          <SidebarLink
            to="services"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            How
          </SidebarLink>
          <SidebarLink
            to="where"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            Where
          </SidebarLink>
          <SidebarLink
            to="contact"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-60}
            onClick={toggle}
          >
            Contact
          </SidebarLink>
          <SidebarLink>
          <Button onClick={() => window.open("https://www.youtube-nocookie.com/embed/OTCD5fQI8q8?autoplay=1&mute=1", "_blank", "fullscreen=yes")}> Switch Off</Button>
          </SidebarLink>
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
